export default "__VITE_ASSET__d4E6vuMA__"